import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\" id=\"icon-arrow-right\"><path d=\"M.333 8.333 3.666 5 .333 1.667 1 .333 5.666 5 1 9.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol